import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import ReducedLessonCard from './subcomponents/ReducedLessonCard';
import ReducedTrackCard from './subcomponents/ReducedTrackCard';
import { ReducedPlaylistCard } from '../../../features/savedItems';

const ReducedContentCard = (_ref) => {
  let {
    contentType,
    contentId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["contentType", "contentId"]);

  if (contentType === 'track') {
    return /*#__PURE__*/_jsx(ReducedTrackCard, Object.assign({
      trackId: contentId
    }, props));
  } else if (contentType === 'lesson') {
    return /*#__PURE__*/_jsx(ReducedLessonCard, Object.assign({
      lessonId: contentId
    }, props));
  }

  return /*#__PURE__*/_jsx(ReducedPlaylistCard, Object.assign({
    playlistId: contentId
  }, props));
};

export default ReducedContentCard;